export const INTENSIVE_COHORT_DURATION = 8
export const INTENSIVE = 'Intensive'
export const MAX_INTENSIVE_COHORT_DURATION = 9
